const cities = require('./cities.json');
const names = Object.keys(cities).sort((a,b)=>b.length-a.length);
const escaped = names.map(name=>name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
// A closing parenthesis is not a word character: a trailing word boundary
// would split Prayagraj (Allahabad) into two tokens and miss translations.
const pattern = new RegExp('\\b(?:'+escaped.join('|')+')(?!\\w)|\\d+(?:[.,]\\d+)*','gi');
module.exports = function normalize(value) {
 const values = [];
 const text = String(value).replace(/\s+/g,' ').trim();
 const key = text.replace(pattern, match => { const city = names.find(name=>name.toLowerCase()===match.toLowerCase()); const token = '{'+values.length+'}'; values.push(city ? cities[city] : match); return token; });
 return {key,values,text};
};
